import BetsTablePopover from './Components/BetsTablePopover';

export default BetsTablePopover;
